import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react";

import ReactECharts from 'echarts-for-react';
import CardBase from "../../cards/CardBase";
import ListDataTable from '../ListDataTable'
import { MoneyFormate } from "../../MoneyFormate";
import WebServiceContext from "../../../webService/WebServiceContext";

import { Loading } from '../../SVG'
import { BasicContext } from "../../../context/BasicContext";


type PerformersRankingProps = {
    // mdata: Manager.ManagerData[]
}

type PerData = {
    年度: number
    年度累加: number
    monthly: {
        month: string
        value: number

    }[]
    總計: number
}

type RowDataProps = {
    data: PerData[]
    title: string
    unit: string
}

const tableRender = (title: string, data: PerData[]) =>
    <div key={title}>
        <label className="title">{title}</label>
        <div className="tableContainer">
            <ListDataTable className="perRankingTable" dataStr={
                data.map((item: PerData) => {
                    console.log(item)

                    let myObj: any = {}
                    myObj["年度"] = item.年度
                    if (item.總計) {
                        myObj["總計"] = MoneyFormate(item.總計)
                    }
                    for (let i: number = 0; i < item.monthly.length; i++) {
                        myObj[item.monthly[i].month] = MoneyFormate(item.monthly[i].value as number)
                    }
                    return (myObj)
                })
            }
            />
        </div>
    </div>

export default (props: PerformersRankingProps) => {

    const [rdps, setRdps] = useState<RowDataProps[]>([])
    const [title, setTitle] = useState<string>("讀取中")
    const [deptList, setDeptList] = useState<Manager.DeptProps[]>([])
    const [deptNo, setDeptNo] = useState<string>("%")
    const bs = useContext(BasicContext)
    const ws = useContext(WebServiceContext)


    useEffect(() => {
        ws.webservice.asyncGetDeptNO().then((res: any) => {
            const _d: Manager.DeptProps[] = res as Manager.DeptProps[]
            if (_d.length > 0) {
                setDeptList(_d)
            }
        })
        return
    }, [])


    useEffect(() => {
        if (bs.SPType != "" && bs.SPGroupID != "") {
            setRdps([])
            ws.webservice.asyncManagerReader(bs.SPType, bs.SPGroupID, deptNo).then((res: any) => {
                console.log(res)
                const rdps: RowDataProps[] = [];
                for (const key in JSON.parse(res[0].RowData)[0]) {
                    const tempData = JSON.parse(res[0].RowData)[0][key][0]
                    //console.log(tempData)
                    let rdp: RowDataProps = {} as RowDataProps
                    rdp.title = tempData.title
                    rdp.unit = tempData.unit

                    let pds: PerData[] = [];
                    for (const perData of tempData.data) {
                        let pd: PerData = {} as PerData;
                        pd.年度 = perData.年度
                        pd.總計 = perData.總計
                        if (perData.monthly) {
                            pd.monthly = JSON.parse(perData.monthly)
                        }
                        pds.push(pd)
                    }

                    rdp.data = pds
                    rdps.push(rdp)
                }

                setRdps(rdps)
            })
        }
    }, [deptNo, bs.SPType, bs.SPGroupID])


    return (
        <CardBase
            collapseControl={false}
            collapseDisabled={true}
            title={title}
            children={
                <>
                    <select onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                        setDeptNo(event.target.value)
                    }}>
                        <option value="%">不拘</option>
                        {
                            deptList.map((item: Manager.DeptProps, index: number) =>
                                <option key={"deptList_" + index} value={item.dept_no}>{item.name_s}</option>
                            )
                        }
                    </select>
                    {
                        rdps.length == 0 ?
                            <Loading />
                            :
                            <div className="PerformersRanking">
                                <div>
                                    <div >
                                        <Chart rdps={rdps} />
                                    </div>
                                    <div>
                                        {
                                            rdps.map((item: RowDataProps) =>
                                                tableRender(item.title, item.data)
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                    }
                </>
            }
        />
    )
}

type ChartProps = {
    rdps: RowDataProps[]
}

const Chart = (props: ChartProps) => {
    const [rdps, setRdps] = useState<RowDataProps[]>(props.rdps)
    const [currnetPer, setCurrnetPer] = useState<PerData[]>(props.rdps[0].data)
    const [currnetType, setCurrnetType] = useState<string>(props.rdps[0].title)
    return (
        <>
            <div style={{ margin: "10px 0", textAlign: "right" }}>
                {
                    rdps.map((item: RowDataProps, index: number) =>
                        <button key={"btn_" + item.title} className={"hibBtn main small "}
                            onClick={() => {
                                setCurrnetPer(rdps[index].data)
                                setCurrnetType(rdps[index].unit)
                            }}
                        >{item.title}</button>
                    )
                }
            </div>
            <ReactECharts
                notMerge
                style={{
                    height: 400
                }}
                option={{

                    textStyle: {
                        fontSize: '16',
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: currnetPer.map((item: PerData) => {
                            return (item.年度.toString())
                        })
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            formatter: (val: string, index: number) => {

                                if (currnetType == "人") {
                                    return val + currnetType
                                } else {
                                    if (parseFloat(val) >= 100000000) {
                                        return parseFloat(val) / 100000000 + "億"
                                    } else {
                                        return parseFloat(val) / 10000 + "萬"
                                    }
                                }
                            }
                        }
                    },
                    series: currnetPer.map((item: PerData) => {
                        return (
                            {
                                name: item.年度,
                                type: 'line',
                                data: item.monthly.map((item) => item.value)
                            }
                        )
                    })
                }}
            />
        </>
    )
}